import './ShowDashboardProviderShowModal.css';

import { useEffect }              from 'react';
import { observer }               from 'mobx-react';
import { Button }                 from 'antd';
import { Tabs }                   from 'antd';
import ProviderShowModel          from 'models/ProviderShowModel';
import { privateLayoutStore }     from 'stores/index';
import FormattedMessageWrapper    from 'components/App/FormattedMessageWrapper';
import { ApiCollection }          from 'collections/ApiCollection';
import ProviderShowCategoryModel  from 'models/ProviderShowCategoryModel';
import ShowModel                  from 'models/ShowModel';
import ProviderModel              from 'models/ProviderModel';
import { AppForm }                from 'components/App/AppForm';
import { AppFormInjectedProps }   from 'components/App/AppForm';
import ProviderShowForm           from 'forms/ProviderShowForm';
import ProviderShowComponent      from 'containers/Show/components/ProviderShowComponent';

interface ShowDashboardProviderShowModalProps {
  onDeleteProviderShow?: () => void;
  providerCollection: ApiCollection<ProviderModel>;
  providerShowCategoryCollection: ApiCollection<ProviderShowCategoryModel>;
  providerShowCollection: ApiCollection<ProviderShowModel>;
  show: ShowModel;
}

const ShowDashboardProviderShowModal = ({
  closeModal,
  onDeleteProviderShow,
  providerCollection,
  providerShowCategoryCollection,
  providerShowCollection,
  setModalFooter,
  show,
}: ShowDashboardProviderShowModalProps & AppFormInjectedProps) => {
  useEffect(() => {
    setModalFooter([
      <Button key="close" onClick={closeModal}>
        <FormattedMessageWrapper id="Fermer" />
      </Button>,
    ]);
  }, [closeModal, setModalFooter]);

  const items = providerShowCategoryCollection.map(
    (providerShowCategory: ProviderShowCategoryModel, index: number | undefined) => ({
      children: (
        <div className="ShowDashboardProviderShowModal__container">
          <div className="ShowDashboardProviderShowModal__header">
            <h3>
              <FormattedMessageWrapper id="Prestataires" />
            </h3>
            <Button
              onClick={() =>
                AppForm.open(
                  ProviderShowForm,
                  {
                    model: new ProviderShowModel({ show: show.path }),
                    onSuccess: () => {
                      providerShowCollection.list();
                      privateLayoutStore.fetchProvidingData();
                    },
                    providerCollection,
                    providerShowCategory,
                    providerShowCategoryCollection,
                  },
                  { title: <FormattedMessageWrapper id="Ajouter un prestataire" /> },
                )
              }
            >
              <FormattedMessageWrapper id="Ajouter" />
            </Button>
          </div>
          <div>
            {providerShowCollection
              .filter(
                (providerShow: ProviderShowModel) =>
                  providerShow.providerShowCategoryIri === providerShowCategory.iri,
              )
              .map((providerShow: ProviderShowModel) => (
                <ProviderShowComponent
                  displayRightComponent
                  key={providerShow.get('@id')}
                  onDeleteProviderShow={onDeleteProviderShow}
                  onSuccess={() => {
                    providerShowCollection.list();
                    privateLayoutStore.fetchProvidingData();
                  }}
                  providerCollection={providerCollection}
                  providerShow={providerShow}
                  providerShowCategory={providerShowCategory}
                  providerShowCategoryCollection={providerShowCategoryCollection}
                />
              ))}
          </div>
        </div>
      ),
      key: `providerShowCategoryTab-${index ?? 0}`,
      label: providerShowCategory.providerShowCategoryName,
    }),
  );

  return (
    <div id="ShowDashboardProviderShowModal">
      <Tabs
        defaultActiveKey="providerShowCategoryTab-0"
        items={items}
        tabPlacement="start"
      />
    </div>
  );
};

export default observer(ShowDashboardProviderShowModal);
